import React from 'react'

const Error = () => {
    return (
        <div className='error'>
                <h1>There was an Error</h1>
        </div>
    )
}

export default Error